import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccessDeniedComponent } from './shared/components/access-denied/access-denied.component';

const routes: Routes = [
    {
        path: 'instances',
        loadChildren: () => import('./modules/instance/instance.module').then(m => m.InstanceModule)
    },
    {
        path: 'property-record',
        loadChildren: () => import('./modules/property-record/property-record.module').then(m => m.PropertyRecordModule)
    },
    {
        path: 'scheduler',
        loadChildren: () => import('./modules/scheduler/scheduler.module').then(m => m.SchedulerModule)
    },
    {
        path: 'console',
        loadChildren: () => import('./modules/console/console.module').then(m => m.ConsoleModule)
    },
    {
        path: 'access-denied',
        component: AccessDeniedComponent
    },
    {
        path: '**',
        redirectTo: 'instances'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
